"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineLocale = void 0;
exports.unwrapPromise = unwrapPromise;
exports.debugPrintPathUrlLike = debugPrintPathUrlLike;
/**
 * Takes the navigators locale string and returns only the recognized
 * supported language. In this case de / or en-US
 * @param navigatorLocale
 * @returns
 */
const determineLocale = (navigatorLocale) => {
    let locale = undefined;
    if (navigatorLocale.includes("de")) {
        locale = 'de-DE';
    }
    else if (navigatorLocale.includes('en')) {
        locale = 'en-US';
    }
    else {
        locale = 'en-US';
    }
    return locale;
};
exports.determineLocale = determineLocale;
async function unwrapPromise(input) {
    try {
        const data = await input;
        return [data, null];
    }
    catch (error) {
        console.log(error);
        return [null, error];
    }
}
function debugPrintPathUrlLike(segments) {
    return segments.join("/");
}
